import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {AceEditorModule} from 'ng2-ace-editor';
import {WidgetCustomizationAiModalComponent} from './widget-customization-ai-modal.component';

@NgModule({
  declarations: [WidgetCustomizationAiModalComponent],
  imports: [CommonModule, ReactiveFormsModule, AceEditorModule],
  exports: [WidgetCustomizationAiModalComponent]
})
export class WidgetCustomizationAiModule {}
